import ALASKA from "./img/ALASKA.jpg";
import SIKATEX from "./img/SIKA TEX.jpg";
import RAP920 from "./img/RAP 720.jpg";
import RAP720 from "./img/RAP 720.jpg";
import SIKALASTIC560 from "./img/SIKALASTIC 560.jpg";
import INERTOLTECH from "./img/INERTOLTECH.jpg";
import CHAPA from "./img/CHAPA.jpg";
import CHAPATRASLÚCIDA from "./img/CHAPA TRASLUCIDA.jpg";
import ROLACPLATA from "./img/ROLAC PLATA.jpg";
import EPSACANALDO from "./img/EPS ACANALDO.jpg";
import REDDESOSTÉN from "./img/RED DE SOSTÉN.jpg";
import LADRILLOEPS from "./img/LADRILLO EPS.jpg";
import THERMOESPUMA from "./img/THERMOESPUMA.jpg";
import TAPUME from "./img/TAPUME.jpg";
import ECOFORM from "./img/ECOFORM.jpg";
import CAÑOESTRUCTURAL from "./img/CAÑO ESTRUCTURAL.jpg";
import CORREAS from "./img/CORREAS.jpg";
import ANCLAJESQUÍMICOS from "./img/ANCLAJES QUÍMICOS.jpg";
import SIKACERAMIMPERMEABLE from "./img/SIKA CERAM FLEXIBLE.jpg";
import SIKACERAMPORCELANATO from "./img/SIKA CERAM PORCELANATO.jpg";
import SIKACERAMFLEXIBLE from "./img/SIKA CERAM FLEXIBLE.jpg";
import SIKABINDAFIX from "./img/SIKA BINDA FIX.jpg";
import ITALFLEX from "./img/ITALFLEX.jpg";
import FONDOFLEX from "./img/FONDOFLEX.jpg";
import PRADERALÁTEXINTERIOR from "./img/PRADERA LÁTEX INTERIOR.jpg";
import BASECOAT from "./img/BASECOAT.png";
import MALLAFIBRADEVIDRIO from "./img/MALLA FIBRA DE VIDRIO.jpg";

export default {
  ALASKA: ALASKA,
  SIKATEX: SIKATEX,
  RAP720: RAP920,
  RAP720: RAP720,
  SIKALASTIC560: SIKALASTIC560,
  INERTOLTECH: INERTOLTECH,
  CHAPA: CHAPA,
  CHAPATRASLÚCIDA: CHAPATRASLÚCIDA,
  ROLACPLATA: ROLACPLATA,
  EPSACANALDO: EPSACANALDO,
  REDDESOSTÉN: REDDESOSTÉN,
  LADRILLOEPS: LADRILLOEPS,
  THERMOESPUMA: THERMOESPUMA,
  TAPUME: TAPUME,
  ECOFORM: ECOFORM,
  CAÑOESTRUCTURAL: CAÑOESTRUCTURAL,
  CORREAS: CORREAS,
  ANCLAJESQUÍMICOS: ANCLAJESQUÍMICOS,
  SIKACERAMIMPERMEABLE: SIKACERAMIMPERMEABLE,
  SIKACERAMPORCELANATO: SIKACERAMPORCELANATO,
  SIKACERAMFLEXIBLE: SIKACERAMFLEXIBLE,
  SIKABINDAFIX: SIKABINDAFIX,
  ITALFLEX: ITALFLEX,
  FONDOFLEX: FONDOFLEX,
  PRADERALÁTEXINTERIOR: PRADERALÁTEXINTERIOR,
  BASECOAT: BASECOAT,
  MALLAFIBRADEVIDRIO: MALLAFIBRADEVIDRIO,
};
